import { render, staticRenderFns } from "./InviteesListItem.vue?vue&type=template&id=60c95508&scoped=true"
import script from "./InviteesListItem.vue?vue&type=script&lang=js"
export * from "./InviteesListItem.vue?vue&type=script&lang=js"
import style0 from "./InviteesListItem.vue?vue&type=style&index=0&id=60c95508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c95508",
  null
  
)

export default component.exports